import React from 'react'
import {
  EmarModuleCard,
  FamilyPlanModuleCard,
} from '@lmc/ui-kit'
import { PaywallTemplateWrapper } from '../../../../components/generic/PaywallTemplateWrapper'
import { colors } from '@lmc/common/constants'
import { IconType } from '@lmc/ui-kit'
import { colours } from '@lmc/ui-kit/src/config/theme'

interface StateProps {
}

const ZonesPaywallComponent: React.FC<StateProps> = () => {
  return (
    <PaywallTemplateWrapper
      backgroundColor={colours.status.popout}
      title="Zones"
      subTitle="Group your service users into zones, e.g. based on floors, wings, or even beds."
      bodyText="Help your team navigate their way around."
      icon={IconType.ProHexagon}
      videoUrl="https://www.youtube.com/embed/R6-VlPq0m9o"
      articles={[
        {
          title: 'How do I set up zones?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/articles/3046855-how-do-i-set-up-zones',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white,
        },
        {
          title: 'How do I select a zone?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/articles/3054739-how-do-i-select-a-zone',
          iconBackgroundColour: colors.green,
          iconColour: colors.white,
        },
        {
          title: 'What other features do I get with Pro?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white,
        },
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      findOutMoreURL="https://logmycare.co.uk/features/service-efficiency"
      customLinkText="Read more"
    />
  )
}

export const ZonesPaywall = ZonesPaywallComponent
